<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row style="height: 36px">
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="公司名称">
              <el-select v-model="searchCondition.company_id" filterable clearable placeholder="请选择公司">
                <el-option
                  v-for="item in allCompanyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传状态">
              <el-select
                clearable
                v-model="searchCondition.upload_bill_status"
                placeholder="审核状态"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>

        <ApeTable ref="apeTable" :data="tableList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            v-if="buttonType=='text'"
            width="120"
            header_align='center'
            align='center'
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button v-if="userPermissions.includes('delay_setting')"  size="mini" type="primary" @click="delayTimeSet(scope.row)">延迟设定</el-button>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <delay-time-set ref='delayTimeSet' title='延迟上传' @refresh='init'></delay-time-set>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import delayTimeSet from './delayTimeSet.vue'
import { mapGetters, mapState} from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    delayTimeSet
  },
  data() {
    return {
      allCompanyList:[],
      cur_item:{}, //选中的列表的某一列
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      columns: [
        {
          title: '公司名称',
          value: 'company_name',
          width: 170,
          header_align: 'center',
          align: 'center',
        },
        {
          title: '任务名称',
          value: 'name',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '业务清单状态',
          value: 'upload_bill_status_text',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '默认上传时间',
          value: 'default_upload_time',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '延迟后上传时间',
          value: 'delay_time',
          header_align: 'center',
          align: 'center',
        },
      ],
      // 表格列表数据
      tableList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      id: '',
      options: [
        {
          value: "1",
          label: "已上传",
        },
        {
          value: "2",
          label: "未上传",
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    async getCompanyList(){
      let result = await this.$api.getUserCompanyList()
      this.allCompanyList = result
    },
    removePicker(){
      this.searchCondition.start_time=''
      this.searchCondition.end_time=''
      console.log('removePicker')
    },

    // 搜索
    searchButton() {
      this.init('search')
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id)
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
    delayTimeSet(item){
      this.$refs.delayTimeSet.open(item)
    },
    //获取选中日期的值
    dataSearch(value) {
      console.log();
      if(value == null ){
        let time = this.$refs.dataSelect.value
        this.searchCondition.start_time = time[0]
        this.searchCondition.end_time = time[1]
        return
      }
      this.searchCondition.start_time = value[0]
      this.searchCondition.end_time = value[1]
    },
    // 初始化列表
    async init(type) {
      let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || {page_size:10,current_page:1}
      if (type == 'export') {
        pagingInfo.page_size = 50000
        console.log(pagingInfo,'页面对象')
      } else {
        this.loadingStaus=true
      }
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo,{ succeed_num:1})
      let {data, pages} = await this.$api.getAdminTaskList(searchCondition)
      if (type == 'export') {
        return data
      } else {
        this.tableList = []
        this.$nextTick(() => {
          this.tableList=data
        })
        this.pagingData.total = pages.total
        console.log(this.pagingData.total,'总数')
        this.offset = pages.offset
        this.loadingStaus=false
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id
      }
      if (this.searchCondition.upload_bill_status) {
        condition.upload_bill_status = this.searchCondition.upload_bill_status
      }
      return condition
    },

    keyupSubmit(){
      document.onkeydown = e => {
        console.log(e)
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },
  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
    this.getCompanyList()
  },
}
</script>

<style lang="stylus" scoped>
  .table-right
    float right
  .main-page-content
    position: relative

</style>
